


// // src/pages/Healing.js
// import React, { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// function Healing() {
//   const [expandedHealingContent, setExpandedHealingContent] = useState(false);
//   const healingRef = useRef(null);

//   useEffect(() => {
//     if (expandedHealingContent && healingRef.current) {
//       healingRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   }, [expandedHealingContent]);

//   const toggleHealingContent = () =>
//     setExpandedHealingContent(!expandedHealingContent);

//   const sectionVariant = {
//     hidden: { opacity: 0, y: 50 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
//   };

//   const cardVariant = {
//     hidden: { opacity: 0, y: 30 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//     hover: { scale: 1.05, boxShadow: "0 12px 30px rgba(0,0,0,0.2)" },
//   };

//   return (
//     <div
//       style={{
//         fontFamily: "'Poppins', sans-serif",
//         background: "#fafafa",
//       }}
//     >
//       {/* 🌼 Healing Section */}
//       <motion.section
//         className="mt-5 p-5"
//         style={{
//           background: "linear-gradient(120deg,#ffb85c,#ff7e5f)",
//           borderRadius: "18px",
//           boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.15)",
//         }}
//         variants={sectionVariant}
//         initial="hidden"
//         animate="visible"
//       >
//         <h2
//           className="text-center mb-4"
//           style={{
//             color: "#fff",
//             fontWeight: "800",
//             fontSize: "2.8rem",
//             textTransform: "uppercase",
//             letterSpacing: "1px",
//           }}
//         >
//           Bhaktamar Stotra Healing
//         </h2>
//         <p
//           style={{
//             fontSize: "1.3rem",
//             lineHeight: "1.8",
//             textAlign: "center",
//             color: "#fff",
//             maxWidth: "850px",
//             margin: "0 auto",
//           }}
//         >
//           The Bhaktamar Stotra is a revered Jain hymn long associated with
//           healing properties for both mental and physical well-being.  
//           Click below to explore the healing effects of each shloka. 👇
//         </p>

//         {/* Expandable Healing List */}
//         <AnimatePresence>
//           {expandedHealingContent && (
//             <motion.div
//               ref={healingRef}
//               key="healing-content"
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: "auto" }}
//               exit={{ opacity: 0, height: 0 }}
//               transition={{ duration: 0.8 }}
//               style={{
//                 overflow: "hidden",
//                 marginTop: "25px",
//                 background: "#fff",
//                 padding: "25px",
//                 borderRadius: "12px",
//                 boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//               }}
//             >
//               <h3 style={{ color: "#e1742c", fontWeight: "700" }}>
//                 Shlokas & Healing Effects
//               </h3>
//               <ul
//                 style={{
//                   color: "#444",
//                   lineHeight: "1.8",
//                   fontSize: "1.1rem",
//                   paddingLeft: "20px",
//                   marginTop: "15px",
//                 }}
//               >
//                   <li><strong>Shloka 1:</strong> Removes disturbances and hindrances.</li>
//                   <li><strong>Shloka 2:</strong> Eliminates chronic headache.</li>
//                   <li><strong>Shloka 3:</strong> Improves vision and cures eye disease.</li>
//                   <li><strong>Shloka 4:</strong> Saves from trouble of any depth.</li>
//                   <li><strong>Shloka 5:</strong> Cures vision-related issues.</li>
//                   <li><strong>Shloka 6:</strong> For steadying the mind, improving prospects for education, strengthening IQ, and memory.</li>
//                   <li><strong>Shloka 7:</strong> For removing snake venom and negativity.</li>
//                   <li><strong>Shloka 8:</strong> For removing all troubles in life.</li>
//                   <li><strong>Shloka 9:</strong> To beget male progeny.</li>
//                   <li><strong>Shloka 10:</strong> To strengthen the bond between employers & employees, and for removing dog poison.</li>
//                   <li><strong>Shloka 11:</strong> To convert salty water into drinkable water.</li>
//                   <li><strong>Shloka 12:</strong> For domestic and family bliss.</li>
//                   <li><strong>Shloka 13:</strong> For a safe journey.</li>
//                   <li><strong>Shloka 14:</strong> For ridding you of fear of enemies and eliminating vata diseases.</li>
//                   <li><strong>Shloka 15:</strong> For honour and respect in life.</li>
//                   <li><strong>Shloka 16:</strong> For putting out fire/negativity.</li>
//                   <li><strong>Shloka 17:</strong> For curing gastrointestinal diseases.</li>
//                   <li><strong>Shloka 18:</strong> For removing illusion.</li>
//                   <li><strong>Shloka 19:</strong> For acquiring a job, promotion, and salary hike.</li>
//                   <li><strong>Shloka 20:</strong> For conception and improving fertility.</li>
//                   <li><strong>Shloka 21:</strong> For achieving a strong bond between family members.</li>
//                   <li><strong>Shloka 22:</strong> Removes fear caused by ghosts & devils/to win lawsuits.</li>
//                   <li><strong>Shloka 23:</strong> Protects from the evil eye, bad spirits, the effect of black magic, for winning court cases.</li>
//                   <li><strong>Shloka 24:</strong> Heals half headaches, migraines, and vertigo.</li>
//                   <li><strong>Shloka 25:</strong> Protects from the evil eye, and attack by enemies.</li>
//                   <li><strong>Shloka 26:</strong> Relieves labour pains while giving birth to a baby.</li>
//                   <li><strong>Shloka 27:</strong> Subdues the enemy and defeats him.</li>
//                   <li><strong>Shloka 28:</strong> For fulfilling wishes, curing leprosy.</li>
//                   <li><strong>Shloka 29:</strong> Overcoming any form of addiction.</li>
//                   <li><strong>Shloka 30:</strong> Success and affluence.</li>
//                   <li><strong>Shloka 31:</strong> For curing skin disease.</li>
//                   <li><strong>Shloka 32:</strong> For curing all types of pain in the abdomen & diarrhoea.</li>
//                   <li><strong>Shloka 33:</strong> Removes all sorts of fevers.</li>
//                   <li><strong>Shloka 34:</strong> Prevents miscarriages, protects the womb.</li>
//                   <li><strong>Shloka 35:</strong> Protect us from hysteria, and other natural calamities.</li>
//                   <li><strong>Shloka 36:</strong> For prosperity in trading, removing Vastu Dosh, and activating the third eye.</li>
//                   <li><strong>Shloka 37:</strong> Changes a cruel person into a kind person.</li>
//                   <li><strong>Shloka 38:</strong> To bring under control intoxicated humans or elephants.</li>
//                   <li><strong>Shloka 39:</strong> Removes past karmas.</li>
//                   <li><strong>Shloka 40:</strong> Eliminates the fear of fire.</li>
//                   <li><strong>Shloka 41:</strong> For curing snake poison.</li>
//                   <li><strong>Shloka 42:</strong> Helps to stop the war.</li>
//                   <li><strong>Shloka 43:</strong> For maintaining international peace and harmony.</li>
//                   <li><strong>Shloka 44:</strong> For eliminating storms.</li>
//                   <li><strong>Shloka 45:</strong> For curing incurable & life-threatening diseases.</li>
//                   <li><strong>Shloka 46:</strong> To be free from the birth-death cycle.</li>                 
//                   <li><strong>Shloka 47:</strong> For becoming fearless.</li>
//                   <li><strong>Shloka 48:</strong> For wealth, prosperity, and liberation.</li>
//                 )
//               </ul>
//             </motion.div>
//           )}
//         </AnimatePresence>

//         {/* Toggle Button */}
//         <div className="text-center">
//           <motion.button
//             onClick={toggleHealingContent}
//             style={{
//               background: "#fca311",
//               border: "none",
//               color: "#fff",
//               padding: "12px 30px",
//               borderRadius: "30px",
//               fontSize: "1rem",
//               fontWeight: "600",
//               cursor: "pointer",
//               marginTop: "25px",
//               boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
//             }}
//             whileHover={{
//               backgroundColor: "#ff4b2b",
//               scale: 1.05,
//             }}
//             whileTap={{ scale: 0.95 }}
//           >
//             {expandedHealingContent ? "Read Less" : "Read More"}
//           </motion.button>
//         </div>
//       </motion.section>

//       {/* 📚 Articles Section */}
//       <motion.section
//         className="mt-5 p-5"
//         style={{
//           backgroundColor: "#fff",
//           borderRadius: "18px",
//           boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.1)",
//         }}
//         variants={sectionVariant}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <h2
//           className="text-center mb-5"
//           style={{ color: "#2c3e50", fontWeight: "800", fontSize: "2.2rem" }}
//         >
//           Articles on Bhaktamar Healing
//         </h2>
//         <div className="row justify-content-center">
//           {[
//             {
//               title: "Bhaktamar Mantra Healing: Explanation & Benefits",
//               desc: "Learn about the healing power and benefits of Bhaktamar mantra.",
//               link: "https://bhaktamarmantrahealing.com/",
//             },
//             {
//               title: "Jain Anusthan: Healing Practices & Bhaktamar Stotra",
//               desc: "An exploration of Jain healing practices and the role of Bhaktamar Stotra.",
//               link: "https://www.jainanusthan.com/bhaktamar-mantra-healing/",
//             },
//             {
//               title: "Scientific Journal on Bhaktamar Healing",
//               desc: "Read about the scientific studies on the healing power of Bhaktamar.",
//               link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC9358100/",
//             },
//           ].map((article, index) => (
//             <motion.div
//               key={index}
//               className="col-lg-4 col-md-6 col-sm-12 mb-4"
//               variants={cardVariant}
//               initial="hidden"
//               whileInView="visible"
//               whileHover="hover"
//               viewport={{ once: true }}
//             >
//               <div
//                 style={{
//                   background: "#fafafa",
//                   borderRadius: "15px",
//                   padding: "20px",
//                   border: "2px solid #ffb834",
//                   textAlign: "center",
//                   height: "100%",
//                 }}
//               >
//                 <h4 style={{ color: "#e1742c", fontWeight: "700" }}>
//                   {article.title}
//                 </h4>
//                 <p style={{ fontSize: "1rem", margin: "15px 0" }}>
//                   {article.desc}
//                 </p>
//                 <a
//                   href={article.link}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-block",
//                     background: "#fca311",
//                     color: "#fff",
//                     padding: "10px 20px",
//                     borderRadius: "25px",
//                     textDecoration: "none",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Read Article
//                 </a>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </motion.section>

//       {/* 🎥 Videos Section */}
//       <motion.section
//         className="mt-5 p-5"
//         style={{
//           background: "linear-gradient(135deg,#fff7e6,#ffe9d6)",
//           borderRadius: "18px",
//           boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.1)",
//         }}
//         variants={sectionVariant}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <h2
//           className="text-center mb-5"
//           style={{ color: "#333", fontWeight: "800", fontSize: "2.2rem" }}
//         >
//           Videos on Bhaktamar Healing
//         </h2>
//         <div className="row justify-content-center">
//           {[
//             {
//               src: "https://www.youtube.com/embed/NQR7jt5m90k",
//               title: "Shree Pranamsagarji Maharaj: Bhaktamar Healing Video",
//             },
//             {
//               src: "https://www.youtube.com/embed/KQxgRe9DznQ",
//               title: "All in One Bhaktamar Solution by Dr. Pranamsagarji Maharaj",
//             },
//             {
//               src: "https://www.youtube.com/embed/LvdFhubTRzU?start=79",
//               title: "Shree Pranamsagarji Maharaj: Bhaktamar Healing Video",
//             },
//           ].map((video, index) => (
//             <motion.div
//               key={index}
//               className="col-lg-4 col-md-6 col-sm-12 mb-4"
//               variants={cardVariant}
//               initial="hidden"
//               whileInView="visible"
//               whileHover="hover"
//               viewport={{ once: true }}
//             >
//               <div
//                 style={{
//                   background: "#fff",
//                   borderRadius: "15px",
//                   padding: "15px",
//                   border: "2px solid #ffb834",
//                   textAlign: "center",
//                   height: "100%",
//                 }}
//               >
//                 <iframe
//                   width="100%"
//                   height="220"
//                   src={video.src}
//                   title={video.title}
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                   allowFullScreen
//                   style={{ borderRadius: "12px" }}
//                 ></iframe>
//                 <h5
//                   className="mt-3"
//                   style={{ fontWeight: "700", color: "#e1742c" }}
//                 >
//                   {video.title}
//                 </h5>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </motion.section>

//       {/* 📱 Responsive Styles */}
//       <style>
//         {`
//           @media (max-width: 992px) {
//             h2 {
//               font-size: 2rem !important;
//             }
//             p {
//               font-size: 1.05rem !important;
//             }
//             .p-5 {
//               padding: 2rem 1.5rem !important;
//             }
//           }

//           @media (max-width: 576px) {
//             h2 {
//               font-size: 1.6rem !important;
//               line-height: 1.4;
//             }
//             p {
//               font-size: 1rem !important;
//             }
//             button {
//               width: 100%;
//             }
//             iframe {
//               height: 200px !important;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// }

// export default Healing;


import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

function Healing() {
  const [expandedHealingContent, setExpandedHealingContent] = useState(false);
  const healingRef = useRef(null);

  useEffect(() => {
    if (expandedHealingContent && healingRef.current) {
      healingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [expandedHealingContent]);

  const toggleHealingContent = () =>
    setExpandedHealingContent(!expandedHealingContent);

  const sectionVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const cardVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    hover: {
      scale: 1.05,
      boxShadow: "0 12px 25px rgba(255,200,120,0.4)",
    },
  };

  return (
    <div
      style={{
        fontFamily: "'Poppins', sans-serif",
        background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
        color: "#4b2e05",
      }}
    >
      {/* 🌿 Hero Healing Section */}
      <motion.section
        className="mt-5 p-5 text-center"
        style={{
          background: "linear-gradient(120deg, #ffd6b5, #ffebb0, #fff4e2)",
          borderRadius: "20px",
          boxShadow: "0px 8px 30px rgba(255,200,100,0.25)",
          position: "relative",
          overflow: "hidden",
        }}
        variants={sectionVariant}
        initial="hidden"
        animate="visible"
      >
        {/* Soft Decorative Glow */}
        <div
          style={{
            position: "absolute",
            top: "-60px",
            right: "-80px",
            width: "220px",
            height: "220px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.4), transparent)",
            borderRadius: "50%",
            zIndex: 0,
          }}
        ></div>

        <motion.h2
          className="mb-3"
          style={{
            color: "#5a3a0e",
            fontWeight: "800",
            fontSize: "2.8rem",
            textShadow: "0 2px 10px rgba(255,220,150,0.5)",
            zIndex: 1,
            position: "relative",
          }}
        >
          Bhaktamar Stotra Healing
        </motion.h2>

        <motion.p
          style={{
            fontSize: "1.25rem",
            lineHeight: "1.8",
            maxWidth: "850px",
            margin: "0 auto",
            color: "#6b4a2e",
            zIndex: 1,
          }}
        >
          The <strong>Bhaktamar Stotra</strong> carries divine healing vibrations
          that nurture mind, body, and soul.  
          Tap below to explore the healing energy of each sacred verse.
        </motion.p>

        {/* Expandable Healing List */}
        <AnimatePresence>
          {expandedHealingContent && (
            <motion.div
              ref={healingRef}
              key="healing-content"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.8 }}
              style={{
                overflow: "hidden",
                marginTop: "30px",
                background: "#fffaf3",
                padding: "25px",
                borderRadius: "15px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
              }}
            >
              <h3
                style={{
                  color: "#b66b00",
                  fontWeight: "700",
                  marginBottom: "15px",
                }}
              >
                Shlokas & Their Healing Effects
              </h3>
              <ul
                style={{
                  color: "#5a3a0e",
                  lineHeight: "1.8",
                  fontSize: "1.05rem",
                  paddingLeft: "20px",
                  marginTop: "10px",
                }}
              >
                <li><strong>Shloka 1:</strong> Removes disturbances and hindrances.</li>
                   <li><strong>Shloka 2:</strong> Eliminates chronic headache.</li>
                   <li><strong>Shloka 3:</strong> Improves vision and cures eye disease.</li>
                   <li><strong>Shloka 4:</strong> Saves from trouble of any depth.</li>
                   <li><strong>Shloka 5:</strong> Cures vision-related issues.</li>
                   <li><strong>Shloka 6:</strong> For steadying the mind, improving prospects for education, strengthening IQ, and memory.</li>
                   <li><strong>Shloka 7:</strong> For removing snake venom and negativity.</li>
                   <li><strong>Shloka 8:</strong> For removing all troubles in life.</li>
                   <li><strong>Shloka 9:</strong> To beget male progeny.</li>
                   <li><strong>Shloka 10:</strong> To strengthen the bond between employers & employees, and for removing dog poison.</li>
                   <li><strong>Shloka 11:</strong> To convert salty water into drinkable water.</li>
                   <li><strong>Shloka 12:</strong> For domestic and family bliss.</li>
                   <li><strong>Shloka 13:</strong> For a safe journey.</li>
                   <li><strong>Shloka 14:</strong> For ridding you of fear of enemies and eliminating vata diseases.</li>
                   <li><strong>Shloka 15:</strong> For honour and respect in life.</li>
                   <li><strong>Shloka 16:</strong> For putting out fire/negativity.</li>
                   <li><strong>Shloka 17:</strong> For curing gastrointestinal diseases.</li>
                   <li><strong>Shloka 18:</strong> For removing illusion.</li>
                   <li><strong>Shloka 19:</strong> For acquiring a job, promotion, and salary hike.</li>
                   <li><strong>Shloka 20:</strong> For conception and improving fertility.</li>
                   <li><strong>Shloka 21:</strong> For achieving a strong bond between family members.</li>
                   <li><strong>Shloka 22:</strong> Removes fear caused by ghosts & devils/to win lawsuits.</li>
                   <li><strong>Shloka 23:</strong> Protects from the evil eye, bad spirits, the effect of black magic, for winning court cases.</li>
                   <li><strong>Shloka 24:</strong> Heals half headaches, migraines, and vertigo.</li>
                   <li><strong>Shloka 25:</strong> Protects from the evil eye, and attack by enemies.</li>
                   <li><strong>Shloka 26:</strong> Relieves labour pains while giving birth to a baby.</li>
                   <li><strong>Shloka 27:</strong> Subdues the enemy and defeats him.</li>
                   <li><strong>Shloka 28:</strong> For fulfilling wishes, curing leprosy.</li>
                   <li><strong>Shloka 29:</strong> Overcoming any form of addiction.</li>
                   <li><strong>Shloka 30:</strong> Success and affluence.</li>
                   <li><strong>Shloka 31:</strong> For curing skin disease.</li>
                   <li><strong>Shloka 32:</strong> For curing all types of pain in the abdomen & diarrhoea.</li>
                   <li><strong>Shloka 33:</strong> Removes all sorts of fevers.</li>
                   <li><strong>Shloka 34:</strong> Prevents miscarriages, protects the womb.</li>
                   <li><strong>Shloka 35:</strong> Protect us from hysteria, and other natural calamities.</li>
                   <li><strong>Shloka 36:</strong> For prosperity in trading, removing Vastu Dosh, and activating the third eye.</li>
                   <li><strong>Shloka 37:</strong> Changes a cruel person into a kind person.</li>
                   <li><strong>Shloka 38:</strong> To bring under control intoxicated humans or elephants.</li>
                   <li><strong>Shloka 39:</strong> Removes past karmas.</li>
                   <li><strong>Shloka 40:</strong> Eliminates the fear of fire.</li>
                   <li><strong>Shloka 41:</strong> For curing snake poison.</li>
                   <li><strong>Shloka 42:</strong> Helps to stop the war.</li>
                   <li><strong>Shloka 43:</strong> For maintaining international peace and harmony.</li>
                   <li><strong>Shloka 44:</strong> For eliminating storms.</li>
                   <li><strong>Shloka 45:</strong> For curing incurable & life-threatening diseases.</li>
                   <li><strong>Shloka 46:</strong> To be free from the birth-death cycle.</li>                 
                   <li><strong>Shloka 47:</strong> For becoming fearless.</li>
                   <li><strong>Shloka 48:</strong> For wealth, prosperity, and liberation.</li>
              </ul>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Toggle Button */}
        <div className="text-center">
          <motion.button
            onClick={toggleHealingContent}
            style={{
              background: "linear-gradient(145deg, #c97b2b, #ffb347)",
              border: "none",
              color: "#fff",
              padding: "12px 35px",
              borderRadius: "50px",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
              marginTop: "25px",
              boxShadow: "0 6px 16px rgba(255,180,80,0.4)",
              transition: "all 0.3s ease",
            }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 8px 25px rgba(255,200,100,0.6)",
            }}
            whileTap={{ scale: 0.95 }}
          >
            {expandedHealingContent ? "Hide List" : "Read More"}
          </motion.button>
        </div>
      </motion.section>

      {/* 📚 Articles Section */}
      <motion.section
        className="mt-5 p-5"
        style={{
          background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        }}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2
          className="text-center mb-5"
          style={{
            color: "#b66b00",
            fontWeight: "700",
            fontSize: "2.4rem",
            textShadow: "0 2px 10px rgba(255,200,150,0.3)",
          }}
        >
          Articles on Bhaktamar Healing
        </h2>

        <div className="row justify-content-center">
          {[
            {
              title: "Bhaktamar Mantra Healing: Explanation & Benefits",
              desc: "Discover the sacred sound frequencies and their therapeutic power.",
              link: "https://bhaktamarmantrahealing.com/",
            },
            {
              title: "Jain Anusthan: Healing Practices & Bhaktamar Stotra",
              desc: "An exploration of Jain healing rituals and Bhaktamar’s spiritual role.",
              link: "https://www.jainanusthan.com/bhaktamar-mantra-healing/",
            },
            {
              title: "Scientific Study on Bhaktamar Healing",
              desc: "Insights from modern research into the healing vibrations of Bhaktamar.",
              link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC9358100/",
            },
          ].map((article, index) => (
            <motion.div
              key={index}
              className="col-lg-4 col-md-6 col-sm-12 mb-4"
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            >
              <div
                style={{
                  background: "#fffaf3",
                  borderRadius: "15px",
                  padding: "25px",
                  border: "1px solid rgba(255,200,150,0.4)",
                  textAlign: "center",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                  transition: "all 0.3s ease",
                }}
              >
                <h4
                  style={{
                    color: "#b66b00",
                    fontWeight: "700",
                    marginBottom: "12px",
                  }}
                >
                  {article.title}
                </h4>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#6b4a2e",
                    lineHeight: "1.7",
                  }}
                >
                  {article.desc}
                </p>
                <a
                  href={article.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    background: "linear-gradient(145deg, #c97b2b, #ffb347)",
                    color: "#fff",
                    padding: "10px 25px",
                    borderRadius: "40px",
                    fontWeight: "600",
                    textDecoration: "none",
                    display: "inline-block",
                    boxShadow: "0 4px 12px rgba(255,150,50,0.4)",
                  }}
                >
                  Read Article
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* 🎥 Videos Section */}
      <motion.section
        className="mt-5 p-5"
        style={{
          background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        }}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2
          className="text-center mb-5"
          style={{
            color: "#b66b00",
            fontWeight: "700",
            fontSize: "2.4rem",
            textShadow: "0 2px 10px rgba(255,200,150,0.3)",
          }}
        >
          Bhaktamar Healing Videos
        </h2>

        <div className="row justify-content-center">
          {[
            {
              src: "https://www.youtube.com/embed/NQR7jt5m90k",
              title: "Bhaktamar Healing by Shri Pranamsagarji Maharaj",
            },
            {
              src: "https://www.youtube.com/embed/KQxgRe9DznQ",
              title: "All-in-One Bhaktamar Healing by Acharya Ji",
            },
            {
              src: "https://www.youtube.com/embed/LvdFhubTRzU?start=79",
              title: "Bhaktamar: Science & Spirituality",
            },
          ].map((video, index) => (
            <motion.div
              key={index}
              className="col-lg-4 col-md-6 col-sm-12 mb-4"
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            >
              <div
                style={{
                  background: "#fffaf3",
                  borderRadius: "15px",
                  padding: "15px",
                  border: "1px solid rgba(255,200,150,0.4)",
                  textAlign: "center",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <iframe
                  width="100%"
                  height="220"
                  src={video.src}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "12px" }}
                ></iframe>
                <h5
                  className="mt-3"
                  style={{
                    fontWeight: "600",
                    color: "#b66b00",
                    fontSize: "1.1rem",
                  }}
                >
                  {video.title}
                </h5>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* 📱 Responsive Styling */}
      <style>
        {`
          @media (max-width: 992px) {
            h2 { font-size: 2rem !important; }
            p { font-size: 1.05rem !important; }
            .p-5 { padding: 2rem 1.5rem !important; }
          }

          @media (max-width: 576px) {
            h2 { font-size: 1.6rem !important; line-height: 1.4; }
            p { font-size: 1rem !important; }
            button { width: 100%; }
            iframe { height: 200px !important; }
          }
        `}
      </style>
    </div>
  );
}

export default Healing;
